import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Grid2, InputLabel, Snackbar, Tab, Typography } from "@mui/material"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useContext, useEffect, useState } from "react";
import { useClientReferalApprovalMutation, useViewClientReferalByIdMutation } from "../../redux/clientReferences/clientReferences.api";
import SearchIconLg from "../../assets/Icons/SearchIcon";
import MUICancelButton from "../../reusable_components/components/MuiCancelButton";
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import AddIcon from '@mui/icons-material/Add';
import { SnackbarContext } from "../../reusable_components/components/Snackbar"
import { useSelector } from "react-redux";
import MUIButton from "../../reusable_components/components/MUIButton";

const ClientReferencesView = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams()

    const { Snackbar } = useContext(SnackbarContext)

    const [ViewClientReferalById, { data: bindingClientRefDetails }] = useViewClientReferalByIdMutation()
    const [clientReferalApproval] = useClientReferalApprovalMutation()


    const [reasonforRej, setReasonForRej] = useState("")
    const [open, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        setReasonForRej("")
    }

    const { clientName, referralId, status } = location?.state || ''

    const { Profile } = useSelector((state) => state.common)

    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const referalId = referralId;

    useEffect(() => {
        try {
            if (referralId) {
                ViewClientReferalById({ referalId })
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }, [referralId, ViewClientReferalById])

    const handleAddClientRefNav = () => {
        navigate('/add-clientref')
    }

    const handleEditClientReferenNav = () => {
        navigate(`/edit-clientref`, { state: { refId: referalId } })
    }

    const handleReasonForRejChange = (e) => {
        const value = e.target.value
        setReasonForRej(value)
    }

    const editScreen = +params?.id

    const handleApproveClientReferal = async (status) => {
        try {
            const payload = {
                adminId: Profile?.profile?.id,
                reason: reasonforRej || "",
                referalId: editScreen,
                status: status
            }

            const response = await clientReferalApproval(payload).unwrap()
            if (response?.status === 200) {
                if (status === "Approved") {
                    Snackbar('Client referal has been Approved Successfully', 'success')
                } else if (status === 'Rejected') {
                    Snackbar('Client referal has been Rejected Successfully', 'success')
                }
                navigate('/client-ref')
            }
        } catch (err) {
            Snackbar('Network error', 'error')
        }
    }

    return (
        <Box className="container">
            <Grid2 item sx={{ display: 'flex', alignItems: 'center', color: '#6941C6', gap: '4px', cursor: 'pointer', width: '40px', marginBottom: '20px' }} onClick={() => navigate('/client-ref')}>
                <ArrowBackIcon sx={{ fontSize: '17px' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '14px' }}>Back</Typography>
            </Grid2>

            <Grid2 sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                <Typography className="title" sx={{}}>{clientName}</Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap' }}>




                    <div>
                        {status === "Pending" ? (
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>

                                <MUICancelButton title='Reject' onClick={() => handleOpen('Rejected')} sx={{ backgroundColor: '#FFF4ED', border: '1px solid #FFD6AE', color: '#D92D20', width: '110px' }} />
                                <MUICancelButton title='Approve' onClick={() => handleApproveClientReferal('Approved')} sx={{ backgroundColor: '#ECFDF3', border: '1px solid #ABEFC6', color: '#067647', width: '110px' }} />
                            </Box>) : (status === "Approved" ? (
                                <MUICancelButton title='Reject' onClick={() => handleOpen('Rejected')} sx={{ backgroundColor: '#FFF4ED', border: '1px solid #FFD6AE', color: '#D92D20', width: '110px' }} />

                            ) : (
                                <MUICancelButton title='Approve' onClick={() => handleApproveClientReferal('Approved')} sx={{ backgroundColor: '#ECFDF3', border: '1px solid #ABEFC6', color: '#067647', width: '110px' }} />

                            )

                        )
                        }
                    </div>


                    <MUICancelButton title='Share' startIcon={<ShareOutlinedIcon sx={{ fontSize: '15px !important' }} />} />
                    <MUIButton startIcon={<AddIcon />} title='Add Referral' onClick={handleAddClientRefNav} sx={{ backgroundColor: '#7F56D9', width: '135px' }} />
                    {Profile?.profile?.role === 'admin' || Profile?.profile?.role === 'coordinator' ?
                        ("") : (<MUIButton title='Edit' className="edit-button" onClick={handleEditClientReferenNav} />
                        )
                    }
                </Box>
            </Grid2>

            <Box>
                <TabContext value={value} >
                    <TabList onChange={handleChange}>
                        <Tab value='1' label="Overview"
                            className="tabs"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 'bold'
                            }}
                        ></Tab>
                    </TabList>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}></Box>

                    <TabPanel value="1" sx={{ display: 'flex', padding: 0.5 }}>
                        {/* box inside the tab  */}
                        {
                            bindingClientRefDetails?.response?.data?.map((item) => (
                                <Box sx={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', marginTop: '10px', gap: '20px' }}>
                                    {/* left grid */}


                                    <Grid2 rowGap={2} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                        <Typography sx={{ fontWeight: 700, fontSize: '18px', }}>Basic Information</Typography>

                                        <Box>
                                            <InputLabel>Client Name</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientName || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>State</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.state || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Contact Number</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientPhone1 || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Contact person</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientContact || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Pincode</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.pincode || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Alternate Number</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientPhone2 || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Opportunity Details</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.opportunityDetails || '-'}</Typography>
                                        </Box>

                                    </Grid2>

                                    <Grid2 rowGap={2} sx={{ width: '100%', display: 'flex', flexDirection: 'column' }} >
                                        <Box>
                                            <InputLabel>Street/Building</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.address1 || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Country</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.country || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Email</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientEmail1 || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>City</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.city || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Website Name</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.website || '-'}</Typography>
                                        </Box>

                                        <Box>
                                            <InputLabel>Alternate Email</InputLabel>
                                            <Typography sx={{ fontSize: '14px' }}>{item?.clientEmail2 || '-'}</Typography>
                                        </Box>
                                    </Grid2>
                                </Box>

                            ))
                        }
                    </TabPanel>
                </TabContext>
            </Box>

            <Grid2 item>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    sx={{
                        "& .MuiDialog-paper": {
                            minHeight: '50vh',
                            minWidth: '45vw'
                        }
                    }}
                    maxWidth='md'
                    scroll="paper"
                >
                    <DialogTitle variant='h6'>Recruiter Rejection</DialogTitle>
                    <DialogContent dividers>
                        <DialogContentText>
                            <InputLabel className="inputlabels">Reason for Rejection <span style={{ color: 'red' }}>*</span></InputLabel>
                            <textarea
                                value={reasonforRej}
                                onChange={handleReasonForRejChange}
                                placeholder="Enter Reason"
                                className="jobPostingTextAreas"
                                style={{ width: '100%', minHeight: '100px' }}
                            />
                        </DialogContentText>

                        <Grid2 item sx={{ display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                            <MUIButton title='Reject'
                                sx={{
                                    backgroundColor: '#CC0000',
                                    "&:disabled": {
                                        backgroundColor: '#fd5c63'
                                    }
                                }}
                                onClick={() => handleApproveClientReferal('Rejected')}
                                disabled={!reasonforRej}
                            />
                            <MUICancelButton title='Cancel' onClick={handleClose} />
                        </Grid2>
                    </DialogContent>
                </Dialog>
            </Grid2>

        </Box>
    )
}
export default ClientReferencesView;